import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHero } from "@/components/PageHero";
import pageCover from "@/assets/kupish/p-povzetek.webp";

export const Route = createFileRoute("/povzetek-pogojev")({
  head: () => ({
    meta: [
      { title: "Povzetek pogojev poslovanja — kupish.si" },
      { name: "description", content: "Kratek povzetek splošnih pogojev poslovanja kupish.si za kupce in ponudnike." },
      { property: "og:title", content: "Povzetek pogojev poslovanja — kupish.si" },
      { property: "og:description", content: "Kratek povzetek splošnih pogojev poslovanja kupish.si za kupce in ponudnike." },
      { property: "og:url", content: "https://kupish.si/povzetek-pogojev" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://kupish.si/povzetek-pogojev" }],
  }),

  component: Page,
});

function Page() {
  return (
    <article className="pb-24">
      <PageHero src={pageCover} alt="Povzetek pogojev kupish.si — minimalističen 3D prikaz dokumentov z lupo">
        <Link to="/pogoji" className="text-xs uppercase tracking-[0.18em] text-accent hover:underline">
          ← Splošni pogoji poslovanja
        </Link>
        <h1 className="font-serif text-4xl md:text-6xl mt-6 leading-[1.05] tracking-tight">
          Povzetek <span className=" text-accent">pogojev</span> poslovanja
        </h1>
        <time className="mt-5 block text-sm text-muted-foreground">Zadnja sprememba: september 2026</time>
      </PageHero>

      <div className="mx-auto max-w-3xl px-6 mt-14 md:mt-20">
        <div className="article-prose">
          <p>
            Kratek pregled najpomembnejših pravil za uporabo platforme. Celotno besedilo najdete v{" "}
            <a href="/pogoji">Splošnih pogojih poslovanja</a>.
          </p>

          <h2>Splošni pogoji poslovanja</h2>
          <ul>
            <li>Za uporabo spletnega mesta je potrebna registracija z resničnimi podatki.</li>
            <li>
              Objavljanje izdelkov temelji na <strong>letnem najemu</strong>. Pri prodaji izdelkov ne
              zaračunavamo provizij ali dodatnih stroškov.
            </li>
            <li>Fotografije morajo prikazovati dejanski predmet, izdelek pa mora biti uvrščen v ustrezno kategorijo.</li>
            <li>Cena v ponudbi mora biti končna in zavezujoča (z DDV, če je prodajalec zavezanec).</li>
            <li>Za zakonitost poslovanja in objav odgovarja izključno uporabnik. Prepovedani so ponarejeni, piratski in nezakoniti izdelki.</li>
            <li>Upravljavec ni odgovoren za spore med kupci in prodajalci.</li>
            <li>Vsebine na kupish.si so avtorsko zaščitene. Kopiranje brez dovoljenja ni dovoljeno.</li>
            <li>Uporabnik je odgovoren za varovanje gesla in obveščanje v primeru zlorabe.</li>
            <li>Upravljavec si pridržuje pravico do izbrisa oglasov ali uporabnikov, ki kršijo pravila ali škodijo portalu.</li>
            <li>Upravljavec ne odgovarja za morebitne napake, izpade delovanja ali izgubo podatkov.</li>
          </ul>

          <h2>Pravila zasebnosti</h2>
          <ul>
            <li>
              Upravljavec osebnih podatkov:{" "}
              <strong>kupish.si – ARTEPIN, spletne rešitve d.o.o., Šišenska cesta 17, Ljubljana</strong>
            </li>
            <li>
              Kontakt: <strong><a href="mailto:info@kupish.si">info@kupish.si</a></strong>
            </li>
            <li>
              Zbiramo naslednje podatke: ime in priimek, e-poštni naslov, kraj/regija, IP, brskalnik, vrsta
              naprave, podatki o uporabi strani.
            </li>
            <li>Podatke pridobimo ob uporabi storitev, kontaktu ali prijavi na obvestila.</li>
            <li>
              Podatki se uporabljajo za izvajanje storitev, analizo uporabe, pošiljanje e-novic in
              personaliziranih obvestil (le z vašo privolitvijo).
            </li>
          </ul>
          <p>
            <strong>Pravice uporabnikov:</strong> dostop do svojih podatkov, popravek netočnih podatkov,
            izbris ("pravica do pozabe"), omejitev obdelave, ugovor neposrednemu trženju, prenosljivost
            podatkov in pritožba pri <strong>Informacijskem pooblaščencu RS</strong>{" "}
            <a href="https://www.ip-rs.si/" target="_blank" rel="noopener noreferrer">www.ip-rs.si</a>.
          </p>
          <p>
            Zahteve glede pravic se pošljejo na:{" "}
            <strong><a href="mailto:info@kupish.si">info@kupish.si</a></strong>.
            Upravljavec mora odgovoriti v roku enega meseca.
          </p>
          <p>
            <strong>Piškotki:</strong> Spletna stran uporablja piškotke za pravilno delovanje, boljšo
            uporabniško izkušnjo in analizo uporabe. Piškotke lahko uporabnik zavrne v brskalniku, vendar v
            tem primeru nekatere funkcije morda ne bodo delovale.
          </p>

          <h2>Reševanje sporov</h2>
          <ul>
            <li>Z oddajo in sprejemom ponudbe nastane obligacijsko razmerje med prodajalcem in kupcem.</li>
            <li>Vsi spori iz tega razmerja (podatki, vsebina ponudbe, predmet, cena) se rešujejo izključno med prodajalcem in kupcem.</li>
            <li>Upravljavec spletnega mesta ne nosi odgovornosti v primeru spora med uporabniki.</li>
            <li>Kupci in prodajalci se zavezujejo k sporazumnemu reševanju sporov v dobri veri.</li>
            <li>Uporabniki se odpovedujejo pravici do odškodninskih zahtevkov proti upravljavcu.</li>
            <li>Za ta pravila se uporablja pravo Republike Slovenije.</li>
            <li>Če sporazumna rešitev ni mogoča, je pristojno stvarno pristojno sodišče v Ljubljani.</li>
          </ul>

          <p>
            Ta povzetek je namenjen preglednosti. Za pravno veljavne informacije se uporabniki sklicujejo na{" "}
            <strong>celotna Splošna pravila poslovanja</strong> in <strong>celotna Pravila zasebnosti</strong>,
            objavljena na kupish.si.
          </p>
        </div>
      </div>
    </article>
  );
}
